import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "rooflead_token";

export const api = axios.create({ baseURL: API });

// Only RoofLead session failures (from the auth dependency) end the session; other 401/403s pass through
const SESSION_401 = new Set(["Missing token", "Invalid token", "Session expired", "Session revoked", "User not found"]);
const SESSION_403 = new Set(["You no longer have access to this organization", "No organization membership"]);
const AUTH_FORM_PATHS = ["/auth/login", "/auth/signup", "/auth/reset-password", "/auth/forgot-password"];

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    const url = error.config?.url || "";
    const sentToken = Boolean(error.config?.headers?.Authorization);
    const isSessionError = (status === 401 && SESSION_401.has(detail)) || (status === 403 && SESSION_403.has(detail));
    if (sentToken && isSessionError && !AUTH_FORM_PATHS.some((p) => url.startsWith(p))) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname.startsWith("/app")) {
        const reason = status === 403 ? "removed" : detail === "Session expired" ? "expired" : "signed_out";
        window.location.assign(`/login?reason=${reason}`);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
